import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { Card, Grid, Icon } from "@mui/material";
import Button from "@/elements/Button";
import typography from "@/theme/base/typography";
import {
  Chart as ChartJS,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  ArcElement,
} from "chart.js";
import { NodoDto, ProprietaMisurataDto } from "@/api";
import ProprietaMisurataLabel from "../../../ProprietaMisurataLabel";
import { useMemo } from "react";
import { classeDiContaminazione } from "@/utils/proprietaMisurataUtils";

ChartJS.register(
  LineController,
  LineElement,
  ArcElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale
);

function ProprietaParticelleMisurateCard({
  dispositivo,
  proprietaMisurate,
  openHistoryDialog,
}: {
  dispositivo: NodoDto;
  proprietaMisurate: ProprietaMisurataDto[];
  openHistoryDialog: () => void;
}) {
  const { size } = typography;
  const danger = true;
  const color = "error";

  const classeContaminazione = useMemo(() => {
    return classeDiContaminazione(proprietaMisurate);
  }, [proprietaMisurate]);

  return (
    <Card sx={{ width: 332, height: 304 }}>
      <Box
        p={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex={1}
        height="100%"
      >
        <Typography
          variant="body2"
          textTransform="capitalize"
          fontWeight="medium"
          color="text"
        >
          {"Particelle ISO"}
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          mb={1}
          flexDirection="column"
          justifyContent="center"
          height="100%"
        >
          <Grid
            container
            rowSpacing={1} // Adjust spacing between grid items
            columnSpacing={2} // Adjust spacing between grid items
            sx={{
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            {proprietaMisurate.map((proprietaMisurata, index) => (
              <Grid item xs={6} key={index}>
                {/* Adjusted to fit max 2 elements per row */}
                <ProprietaMisurataLabel
                dispositivo={dispositivo}
                  proprietaMisurata={proprietaMisurata}
                  value={proprietaMisurata.lastValue || null}
                  alignItems="center"
                  typographyVariantPrimary="h5"
                />
              </Grid>
            ))}
          </Grid>

          {classeContaminazione && (
            <Typography
              variant="body2"
              fontWeight="bold"
              fontSize={size.md}
              textAlign={"center"}
              paddingTop={3}
              color="text"
            >
              Classe di contaminazione<br></br>
              {classeContaminazione}
            </Typography>
          )}
        </Box>

        <Box width="100%" display="flex" flexDirection="row" mt="auto">
          <Button
            variant="textArrow"
            color="text"
            sx={{ ml: "auto", mr: 0, mt: 1, mb: -1 }}
            onClick={openHistoryDialog}
          >
            Vedi storico
          </Button>
        </Box>
      </Box>
    </Card>
  );
}

export default ProprietaParticelleMisurateCard;
